import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { ContactRequest } from '../../models/user.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';

/*
  Generated class for the ContactRequestProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ContactRequestProvider {
  constructor(private api: Api) {}

  sendContactRequest(body: ContactRequest): Observable<any> {
    return this.api.post('social/sendRequest', body).map(res => {
      return res;
    });
  }

  allContactRequest(): Observable<any> {
    return this.api.get('social/allRequests', {}).map(res => {
      return res;
    });
  }

  acceptContactRequest(friend: string): Observable<any> {
    return this.api.post('social/accept', { friend: friend }).map(res => {
      return res;
    });
  }

  cancelContactRequest(friend: string): Observable<any> {
    return this.api
      .post('social/rejectContactRequest', { friend: friend })
      .map(res => {
        return res;
      });
  }

  blockPerson(blockedUser: string): Observable<any> {
    return this.api
      .post('social/block', { blockedUser: blockedUser })
      .map(res => {
        return res;
      });
  }

  deleteContact(friend: string): Observable<any> {
    return this.api
      .post('social/deleteContact', { friend: friend })
      .map(res => {
        return res;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/contact-request/contact-request.ts